import { Link } from 'react-router-dom';
import { trackCTAClick } from '../../../hooks/useAnalytics';
import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <section className="relative py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="space-y-8 max-w-3xl mx-auto">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                Tüm Altyapı ve Güvenlik Sistem Projeleri için Teklif Alın
              </h2>
              <p className="text-lg text-gray-300">
                Uzman ekibimiz 24 saat içinde size ulaşır
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                onClick={() => trackCTAClick('Hemen Ara: +90 553 716 55 61', 'homepage_cta')}
                className="inline-flex items-center px-8 py-4 bg-teal-700 text-white font-bold rounded-lg hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap"
              >
                <i className="ri-customer-service-2-line text-xl mr-2"></i>
                Hemen Ara: +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCTAClick('WhatsApp', 'homepage_cta')}
                className="inline-flex items-center px-8 py-4 bg-green-600 text-white font-bold rounded-lg hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl mr-2"></i>
                WhatsApp
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-12">
              {[
                {
                  icon: 'ri-speed-line',
                  text: 'Hızlı Teklif',
                  gradient: 'from-emerald-500 to-teal-500',
                },
                {
                  icon: 'ri-user-star-line',
                  text: 'Profesyonel Danışmanlık',
                  gradient: 'from-violet-500 to-purple-500',
                },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                  className="flex flex-col items-center text-center p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all duration-300"
                >
                  <div className={`w-16 h-16 bg-gradient-to-br ${item.gradient} rounded-full flex items-center justify-center mb-4`}>
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <span className="text-white font-semibold text-lg">{item.text}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
